/* MAIYKO EKLENTI — Site geneli mini kupon
   theme.liquid'de </body> öncesi yüklenir, HER sayfada çalışır.

   Kupon "copied" VEYA "active" durumundayken ve süresi dolmamışken görünür.
   Değilse hiçbir şey yapmadan çıkar: DOM'a dokunmaz, CSS indirmez.

   v10 — KOPYALANMAMIŞ KOD DA KURTARILIR: eskiden yalnız 'copied' kayıt
   kabul ediliyordu; kodunu alıp kopyalamadan gezinen ziyaretçi kodunu
   kaybediyordu (kod kaybının en sık yolu). Artık 'active' kayıtta da koçan
   çıkar, metni "KODUN HAZIR — DOKUN" olur; dokununca kod kopyalanır, kayıt
   'copied'e çekilir, /discount arka planda sepete işlenir ve koçan mevcut
   mini-kupon görünümüne düşer. Ürün sayfasında bilet bloğu GÖRÜNÜRSE
   'active' koçanı çıkmaz (çift arayüz olurdu); kodu bilet teslim eder.

   Durum kaynağı localStorage (blok JS'i ile aynı şema):
     maiyko_kupon_dyn        -> { kod, bitis, durum, yuzde, stil, konum, alt, bg, fg }
     maiyko_kupon_<KOD>      -> { state, start, bitis, kod, yuzde, stil, konum, alt, bg, fg }
   Stil/konum/yüzde alanları kopyalama anında blok JS'i tarafından yazılır.

   ÇİFT RENDER KORUMASI: tek kimlik #maiyko-mini-global. Ürün sayfasında blok
   mini kuponu zaten kurduysa (aynı id ile) bu script devreye girmez.

   Durum GEÇİŞLERİ: burada YALNIZCA active -> copied yazılır (koçana
   dokunma anı). copied -> used geçişi hâlâ blok JS'inin işidir.
   Burada süre dolunca yalnızca arayüz kaldırılır. */

(function () {
  'use strict';

  var ID = 'maiyko-mini-global';
  var CSS_ID = 'maiyko-kupon-global-css';
  var DYN = 'maiyko_kupon_dyn';
  var ONEK = 'maiyko_kupon_';
  var OK_MS = 1500;
  var TICK_MS = 250;

  /* data-mk-css yalnızca çalışma anında okunabilir (defer'de currentScript geçerli) */
  var betik = document.currentScript;
  var cssUrl = betik ? betik.getAttribute('data-mk-css') : '';

  function now() {
    return new Date().getTime();
  }

  function oku(k) {
    try {
      var r = window.localStorage.getItem(k);
      if (!r) return null;
      var o = JSON.parse(r);
      return o && typeof o === 'object' ? o : null;
    } catch (e) {
      return null;
    }
  }

  function mmss(ms) {
    var t = Math.ceil((ms > 0 ? ms : 0) / 1000);
    var m = Math.floor(t / 60);
    var s = t % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* Aktif kuponu bul: önce dinamik kayıt, sonra sabit anahtarlar.
     'copied' (kopyalanmış) ve 'active' (henüz kopyalanmamış) kabul edilir.
     Dönen nesneye üç yardımcı alan eklenir — hangi anahtarda, hangi durum
     alanında ve kopyalanmış mı: __anahtar / __alan / __kopyalandi. Bunlar
     ASLA localStorage'a geri yazılmaz (bkz. kopyalandiYaz). */
  function aktifBul() {
    var t = now();
    var d = oku(DYN);
    if (d && (d.durum === 'copied' || d.durum === 'active') && typeof d.bitis === 'number' && d.bitis > t) {
      d.__anahtar = DYN;
      d.__alan = 'durum';
      d.__kopyalandi = d.durum === 'copied';
      return d;
    }

    var ls;
    try {
      ls = window.localStorage;
    } catch (e) {
      return null;
    }
    if (!ls) return null;

    for (var i = 0; i < ls.length; i++) {
      var k;
      try {
        k = ls.key(i);
      } catch (e) {
        continue;
      }
      if (!k || k === DYN || k.indexOf(ONEK) !== 0) continue;
      var s = oku(k);
      if (!s || (s.state !== 'copied' && s.state !== 'active')) continue;
      if (typeof s.bitis !== 'number' || s.bitis <= t) continue;
      if (!s.kod) s.kod = k.slice(ONEK.length);
      s.__anahtar = k;
      s.__alan = 'state';
      s.__kopyalandi = s.state === 'copied';
      return s;
    }
    return null;
  }

  /* Kayıt 'copied'e çekilir. Kayıt TAZE okunur ve yalnız durum alanı
     değiştirilir: aktifBul'un eklediği __ alanları depoya sızmaz. */
  function kopyalandiYaz(st) {
    if (!st || !st.__anahtar || !st.__alan) return;
    var ham = oku(st.__anahtar);
    if (!ham) return;
    ham[st.__alan] = 'copied';
    try {
      window.localStorage.setItem(st.__anahtar, JSON.stringify(ham));
    } catch (e) {
      /* gizli modda yoksay */
    }
  }

  /* İndirimi ARKA PLANDA sepete işler (çarkla aynı desen): checkout
     cookie'si yazılır, müşteri kodu kaybetse bile ödemede uygulanır.
     Yönlendirme İZLENMEZ — ziyaretçi bulunduğu sayfada kalır. */
  function indirimiIsle(kodMetni) {
    var url =
      '/discount/' + encodeURIComponent(kodMetni) +
      '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
    try {
      if (typeof window.fetch === 'function') {
        window.fetch(url, { credentials: 'same-origin' })['catch'](function () {});
      } else {
        var img = new Image();
        img.src = url;
      }
    } catch (e) {
      /* yoksay */
    }
  }

  /* Sayfada GÖRÜNÜR bilet bloğu var mı? Varsa kodu bilet teslim eder;
     kopyalanmamış kayıt için koçan çıkmaz (çift arayüz olurdu). */
  function biletGorunurMu() {
    var b;
    try {
      b = document.querySelectorAll('[data-maiyko-kupon]');
    } catch (e) {
      return false;
    }
    for (var i = 0; i < b.length; i++) {
      if (!b[i].hidden) return true;
    }
    return false;
  }

  function cssEnjekte() {
    if (!cssUrl || document.getElementById(CSS_ID)) return;
    try {
      var l = document.createElement('link');
      l.id = CSS_ID;
      l.rel = 'stylesheet';
      l.href = cssUrl;
      (document.head || document.body).appendChild(l);
    } catch (e) {
      /* yoksay */
    }
  }

  function yap(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }

  function kopyala(metin) {
    function yedek() {
      try {
        var ta = document.createElement('textarea');
        ta.value = metin;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {
        /* yoksay */
      }
    }
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        navigator.clipboard.writeText(metin)['catch'](yedek);
        return;
      } catch (e) {
        /* yedeğe düş */
      }
    }
    yedek();
  }

  function kur(st) {
    var kopyalandi = st.__kopyalandi === true;

    /* Kopyalanmamış kodda bilet önceliklidir (yukarıdaki not). */
    if (!kopyalandi && biletGorunurMu()) return null;

    /* Blok GERÇEKTEN kurduysa (mini görünür) global devreye girmez.
       Bilet, YABANCI kampanya (örn. çark kuponu) aktifken kendi minisini
       portallayıp GİZLİ bırakabiliyor — o terkedilmiş kabuk devralınır,
       yoksa biletli sayfalarda çark kuponunun sayacı hiç görünmüyordu. */
    var mevcut = document.getElementById(ID);
    if (mevcut) {
      if (!mevcut.hidden) return null;
      try {
        mevcut.parentNode.removeChild(mevcut);
      } catch (e) {
        return null;
      }
    }
    if (!document.body) return null;

    cssEnjekte();

    /* Tüm bilet stilleri tanınır; çark kuponu kendi 'cark' (kiremit)
       stiline boyanır (koçan görünümü — CSS'te). */
    var carkMi = st.kampanya === 'cark';
    var stiller = { siyah: 1, altin: 1, bronz: 1, gumus: 1, platin: 1, black: 1 };
    var stil = carkMi ? 'cark' : (stiller[st.stil] ? st.stil : 'altin');
    var konum = st.konum === 'right' ? 'right' : 'left';
    var alt = parseInt(st.alt, 10);
    if (!isFinite(alt) || alt < 0) alt = 180;
    var yuzde = parseInt(st.yuzde, 10);
    if (!isFinite(yuzde) || yuzde < 1 || yuzde > 99) yuzde = 0;
    /* Sabit tutarli kupon: kayitta tutar > 0 ise rozet "N₺" olur. */
    var tutar = parseInt(st.tutar, 10);
    if (!isFinite(tutar) || tutar < 10 || tutar > 5000) tutar = 0;
    var ad = tutar ? tutar + ' TL' : (yuzde ? '%' + yuzde : '');

    var kok = yap('div', 'maiyko-kupon-mini maiyko-kupon-mini--' + stil);
    kok.id = ID;
    kok.setAttribute('data-konum', konum);
    try {
      kok.style.setProperty('--mk-mini-alt', alt + 'px');
      if (stil === 'siyah') {
        if (st.bg) kok.style.setProperty('--mk-bg', st.bg);
        if (st.fg) kok.style.setProperty('--mk-fg', st.fg);
      }
    } catch (e) {
      /* yoksay */
    }

    /* --- Sekme: %X + sayaç (KOD GÖRÜNMEZ) ---
       Kopyalanmamış kodda oran bloğunun YERİNE çağrı geçer:
       "KODUN HAZIR — DOKUN | mm:ss HEDİYEN". Sayaç kalır (aciliyet), oran
       gizlenir ki sekme dar kalsın; dokunuşla normal görünüme düşer. */
    var sekme = yap('button', 'maiyko-kupon-mini__sekme');
    sekme.type = 'button';
    sekme.setAttribute('aria-expanded', 'false');
    sekme.setAttribute('aria-label', kopyalandi ? 'İndirim kuponunu aç' : 'İndirim kodunu al');
    var yuzdeEl = yap('span', 'maiyko-kupon-mini__yuzde', tutar ? tutar + '₺' : (yuzde ? '%' + yuzde : ''));
    yuzdeEl.hidden = !kopyalandi || (!tutar && !yuzde);
    var sayacEl = yap('span', 'maiyko-kupon-mini__mmss', mmss(st.bitis - now()));
    var hazirEl = yap('span', 'maiyko-kupon-mini__hazir', 'KODUN HAZIR — DOKUN');
    hazirEl.hidden = kopyalandi;
    sekme.appendChild(yuzdeEl);
    sekme.appendChild(hazirEl);
    sekme.appendChild(sayacEl);
    if (!kopyalandi && kok.classList && kok.classList.add) kok.classList.add('is-hazir');

    /* --- Panel: başlık + kalan + Kodu Kopyala (KOD YİNE GÖRÜNMEZ) ---
       Çark kuponunda dil farklı: 'Hoş geldin hediyen' + indirim ödemede
       otomatik uygulandığı için not düşülür (kod kopyalamak şart değil). */
    var panel = yap('div', 'maiyko-kupon-mini__panel');
    panel.hidden = true;
    var baslikEl = yap(
      'p',
      'maiyko-kupon-mini__baslik',
      carkMi
        ? 'Hoş geldin hediyen' + (ad ? ' — ' + ad + ' indirim' : '')
        : (ad ? 'Sana özel ' + ad + ' indirim' : 'Sana özel indirim')
    );
    panel.appendChild(baslikEl);
    var kalanP = yap('p', 'maiyko-kupon-mini__kalan');
    var kalanEl = yap('span', '', mmss(st.bitis - now()));
    kalanP.appendChild(kalanEl);
    kalanP.appendChild(document.createTextNode(' dk kaldı'));
    panel.appendChild(kalanP);
    if (carkMi) {
      panel.appendChild(yap('p', 'maiyko-kupon-mini__kalan', 'Ödemede otomatik uygulanır.'));
    }
    var btn = yap('button', 'maiyko-kupon-mini__btn', 'Kodu Kopyala');
    btn.type = 'button';
    panel.appendChild(btn);
    var okEl = yap('span', 'maiyko-kupon-mini__ok', '✓ Kopyalandı');
    okEl.hidden = true;
    panel.appendChild(okEl);

    kok.appendChild(sekme);
    kok.appendChild(panel);
    document.body.appendChild(kok);

    var acik = false;
    function ayarla(ac) {
      acik = ac === true;
      panel.hidden = !acik;
      sekme.setAttribute('aria-expanded', acik ? 'true' : 'false');
    }

    /* Kopyalanmamış koçana İLK dokunuş kodu TESLİM eder: panoya kopyalanır,
       kayıt 'copied' olur, indirim arka planda sepete işlenir ve koçan
       mevcut mini-kupon görünümüne düşer (panel açılır ki ziyaretçi ne
       olduğunu görsün). Sonraki dokunuşlar sadece paneli açıp kapatır. */
    function kodTeslim() {
      kopyalandi = true;
      kopyala(st.kod);
      kopyalandiYaz(st);
      indirimiIsle(st.kod);
      hazirEl.hidden = true;
      yuzdeEl.hidden = !tutar && !yuzde;
      if (kok.classList && kok.classList.remove) kok.classList.remove('is-hazir');
      sekme.setAttribute('aria-label', 'İndirim kuponunu aç');
      okEl.hidden = false;
      window.setTimeout(function () {
        okEl.hidden = true;
      }, OK_MS);
      ayarla(true);
    }

    sekme.addEventListener('click', function (e) {
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
      if (!kopyalandi) {
        kodTeslim();
        return;
      }
      ayarla(!acik);
    });

    btn.addEventListener('click', function () {
      kopyala(st.kod);
      okEl.hidden = false;
      window.setTimeout(function () {
        okEl.hidden = true;
      }, OK_MS);
    });

    document.addEventListener('click', function (e) {
      if (!acik) return;
      var h = e && e.target;
      if (h && kok.contains && kok.contains(h)) return;
      ayarla(false);
    });

    document.addEventListener('keydown', function (e) {
      if (!acik) return;
      var k = e && e.key;
      if (k === 'Escape' || k === 'Esc') ayarla(false);
    });

    return { kok: kok, sayac: sayacEl, kalan: kalanEl, baslik: baslikEl, ad: ad };
  }

  /* --- Giriş: aktif kupon yoksa SIFIR maliyetle çık ---

     v11: giriş bir FONKSİYONA alındı ve window.MaiykoMiniGlobalKur olarak
     dışarı açıldı. Sebep: çark artık aboneliği+kuponu TEK istekte bitirip
     sayfayı DEĞİŞTİRMİYOR — eskiden koçan, native gönderimin ardından gelen
     sayfa yüklenmesinde kuruluyordu. Kayıt yazıldıktan sonra çark bu
     fonksiyonu çağırır ve koçan AYNI sayfada belirir. Fonksiyon
     idempotenttir: koçan zaten kuruluysa ya da aktif kayıt yoksa hiçbir şey
     yapmaz, sayfa yükünde davranış birebir eskisi gibidir. */
  var SON3_MS = 3 * 60000; /* SON 3 DK: kalan süre eşiğin altında mini kırmızı faza geçer */
  var gorunum = null;
  var zaman = null;
  var son3Acik = false;

  function temizle() {
    if (gorunum && gorunum.kok && gorunum.kok.parentNode) {
      try {
        gorunum.kok.parentNode.removeChild(gorunum.kok);
      } catch (e) {
        /* yoksay */
      }
    }
    if (zaman) {
      window.clearInterval(zaman);
      zaman = null;
    }
    gorunum = null;
  }

  function son3Dene(kalanMs) {
    if (!gorunum || son3Acik || kalanMs > SON3_MS) return;
    son3Acik = true;
    if (gorunum.kok.classList && gorunum.kok.classList.add) {
      gorunum.kok.classList.add('is-son3');
    }
    if (gorunum.baslik) {
      gorunum.baslik.textContent = gorunum.ad
        ? 'Son 3 dk! ' + gorunum.ad + ' indirim bitmek üzere'
        : 'Son 3 dk! Kod bitmek üzere';
    }
  }

  function baslat() {
    if (gorunum) return; /* koçan zaten kurulu */
    var durum = aktifBul();
    if (!durum || !durum.kod) return;
    var g = kur(durum);
    if (!g) return;
    gorunum = g;
    son3Acik = false;
    son3Dene(durum.bitis - now());
    zaman = window.setInterval(function () {
      /* Kayıt silindiyse ya da süre dolduysa arayüzü kaldır. */
      var s = aktifBul();
      if (!s) {
        temizle();
        return;
      }
      var kalanMs = s.bitis - now();
      if (kalanMs <= 0) {
        temizle();
        return;
      }
      son3Dene(kalanMs);
      var yazi = mmss(kalanMs);
      gorunum.sayac.textContent = yazi;
      gorunum.kalan.textContent = yazi;
    }, TICK_MS);
  }

  try {
    window.MaiykoMiniGlobalKur = baslat;
  } catch (e) {
    /* yoksay */
  }

  baslat();
})();
